import React from 'react'
import { InventoryBySerialNumberCodeInputModal } from '../InlineInput/Code/InventoryBySerialNumberCodeInputModal'
import type { InventoryBySerialNumber } from '@ztechapps/common.contract'
import { InventoryBySerialNumberStatusEnum } from '@ztechapps/common.contract'
import { BusyButton } from '@ztechapps/webui.button'
import type { ModalTriggerProps } from '@ztechapps/webui.modal'
import { Stack } from 'react-bootstrap'
import { InlineDisplayContent, TagsInput, TextInput } from '@ztechapps/webui.input'
import isEmpty from 'lodash/isEmpty'
import { useAddMultipleSerialNumbers } from '@ztechapps/inventorybyserialnumber.common'
import { useError } from '@ztechapps/common.hook'
import { useInventoryBySerialNumberListContext } from './Context'

export const AddInventoryBySerialNumber = () => {
  const [onAdd, { error, loading }] = useAddMultipleSerialNumbers({
    options: {
      mutationOptions: {
        refetchQueries: ['allInventoryBySerialNumber'],
      },
    },
  })
  useError(error)
  const { productId } = useInventoryBySerialNumberListContext()

  const onChange = async (values: InventoryBySerialNumber[]) => {
    if (isEmpty(values)) return
    const newValues = values.map((value) => ({
      ...value,
      remarks,
      tags,
      status: InventoryBySerialNumberStatusEnum.OnHand,
    }))
    //we need to send this to server
    await onAdd({
      inventoryBySerialNumbers: newValues,
      productId,
    })
  }
  const [remarks, setRemarks] = React.useState('')
  const [tags, setTags] = React.useState([])

  const trigger = (modalTriggerProps: ModalTriggerProps) => (
    <BusyButton onClick={modalTriggerProps.onClick} icon={'plus'} text="Add serial numbers..." />
  )

  return (
    <InventoryBySerialNumberCodeInputModal
      isBusy={loading}
      onChange={onChange}
      value={[]}
      trigger={trigger}
      maxQtySerialNumber={-1}
    >
      <Stack gap={2} className="mt-2">
        <div>
          <InlineDisplayContent label="Remarks">
            <TextInput value={remarks} onChange={(e) => setRemarks(e?.target?.value)} />
          </InlineDisplayContent>
        </div>
        <div>
          <InlineDisplayContent label="Tags">
            <TagsInput
              value={tags}
              onChange={(e) => {
                setTags(e)
              }}
            />
          </InlineDisplayContent>
        </div>
      </Stack>
    </InventoryBySerialNumberCodeInputModal>
  )
}
